<dialog-draggable-header>{{this.partChangeId ? 'Update' : 'Add'}} Part Change</dialog-draggable-header>

<mat-dialog-content>
  <form [formGroup]="partChangeForm" class="parts-change-form">
    <div>
      <mat-form-field>
        <mat-label>Release Level:</mat-label>
        <input matInput type="text" formControlName="releaseLevel" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Approval Date:</mat-label>
        <input matInput [matDatepicker]="date" formControlName="approvalDate" />
        <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
        <mat-datepicker #date></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Authority #(alpha):</mat-label>
        <input matInput type="text" formControlName="authNumber" />
        <mat-error *ngIf="partChangeForm.get('authNumber').hasError('avoType')">
          Cannot have Auth Number if AVO type
        </mat-error>
        <mat-error *ngIf="partChangeForm.get('authNumber').hasError('required')">
          Auth Number is required if not AVO Type
        </mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>Authority #(numeric):</mat-label>
        <input matInput type="text" formControlName="authNumberN" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Authority Type:</mat-label>
        <mat-select formControlName="authTypeName">
          <mat-option *ngFor="let authType of authTypes" [value]="authType">{{authType}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>PDI:</mat-label>
        <input matInput type="text" formControlName="pdi" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>Affects Design:</mat-label>
        <mat-select (valueChange)="affectsDesignChanged($event)" formControlName="affectsDesign">
          <mat-option [value]="1">Yes</mat-option>
          <mat-option [value]="0">No</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-checkbox formControlName="designDetail">
        Detail
      </mat-checkbox>
      <mat-checkbox formControlName="designAsm">
        Asm
      </mat-checkbox>
      <mat-checkbox formControlName="designItac">
        ITAC
      </mat-checkbox>
      <mat-checkbox formControlName="designEtac">
        ETAC
      </mat-checkbox>
      <mat-checkbox formControlName="designHaf">
        HandApply Fixt
      </mat-checkbox>
    </div>
    <div>
      <mat-form-field>
        <mat-label>Affects GD&T:</mat-label>
        <mat-select (valueChange)="affectsGdtChanged($event)" formControlName="affectsGdt">
          <mat-option [value]="1">Yes</mat-option>
          <mat-option [value]="0">No</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-checkbox formControlName="gdtDetail">
        Detail
      </mat-checkbox>
      <mat-checkbox formControlName="gdtAsm">
        Asm
      </mat-checkbox>
      <mat-checkbox formControlName="gdtItac">
        ITAC
      </mat-checkbox>
      <mat-checkbox formControlName="gdtEtac">
        ETAC
      </mat-checkbox>
      <mat-checkbox formControlName="gdtHaf">
        Hand Apply Fixt
      </mat-checkbox>
    </div>
    <div>
      <mat-form-field>
        <mat-label>GD&T File Name:</mat-label>
        <input matInput type="text" formControlName="gdtFileName" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Build Event:</mat-label>
        <input matInput type="text" formControlName="buildEvent" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Req'd for NEC:</mat-label>
        <mat-select formControlName="reqdForNec">
          <mat-option [value]="1">Yes</mat-option>
          <mat-option [value]="0">No</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="mat-dialog-actions-end no-margin">
  <button mat-raised-button color="primary" [disabled]="partChangeForm.invalid" (keypress.enter)="save()"
    (click)="save()">
    {{partChangeId ? 'Update' : 'Save'}}
  </button>
  <button mat-raised-button mat-dialog-close >Cancel</button>
</mat-dialog-actions>